export default "__VITE_ASSET__bCUkkzMQ__"